// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QtcF","right":"styles_right__1UOmg"};